import { render, staticRenderFns } from "./ContactLocation.vue?vue&type=template&id=4d5ded85&scoped=true&"
import script from "./ContactLocation.vue?vue&type=script&lang=js&"
export * from "./ContactLocation.vue?vue&type=script&lang=js&"
import style0 from "./ContactLocation.vue?vue&type=style&index=0&id=4d5ded85&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d5ded85",
  null
  
)

export default component.exports